<div class="overLayDiv active"></div>
<div id="rightSideBar">
    <div class="rightSidePanel w-50pc d-flex flex-column">
        <header class="panel-header">
            <div class="viewDemo title-and-video">
                <h2>{{ 'grant_access' | translate }}</h2>
            </div>
            <div class="panel-left-btn">
                <button type="button" class="btn eod-btn-outline-warning " (click)="fnClosePanel()">
                    {{ 'label_close' | translate }}
                </button>
            </div>
        </header>
   <div class="eod-panel-body">

     <div class="block bg-transparent mt-0">
            <h6 class="m-0">{{this.inputModel?.userName}} {{ 'company_grant_access_text1' | translate }} {{this.companyList?.length}}
                {{ 'company_grant_access_text2' | translate }}
            </h6>
        </div>

        <div class="block mt-0 mb-2" *ngFor="let company of companyList">
            <h6 class="info-text note"><strong>{{company.companyName}}</strong></h6>
            <h6 class="info-text fw-600"><span>{{ 'company_grant_access_text3' | translate}} <strong>{{this.inputModel?.userName}}</strong>
                    <strong>({{this.inputModel?.email}})</strong> {{ 'company_grant_access_text4' | translate}}</span></h6>

            <div class="radio-button border-0 p-0">

                <input type="checkbox" name="reminderOption" class="align-middle svg-20 cursor-pointer disabled" 
                [(ngModel)]="company.isAccessAssigned">
                <label class="">
                    {{ 'company_grant_access_text5' | translate}}
                </label>
            </div>

            <div class="radio-button border-0 p-0">

                <input type="checkbox" name="reminderOption" class="align-middle svg-20 cursor-pointer" 
                [(ngModel)]="company.isJustificationRequired">
                <label class="">
                    {{ 'company_grant_access_text6' | translate}}
                </label>
            </div>

            <div class="d-flex gap-2 mt-2">
                <button type="button" class="btn eod-btn-primary" (click)="fnApproveRejectCompanyAccessRequest(company,2)">
                    {{ 'label_approve' | translate}}
                </button>
                <button type="button" class="btn eod-btn-outline-danger" (click)="fnApproveRejectCompanyAccessRequest(company,3)">
                    {{ 'reject' | translate}}
                </button>
            </div>
        </div>

   </div>

    </div>
</div>



<!----------------------Side Panels--------------------------->

<app-alert-panel *ngIf="showRejectConfirmationAlert" [data]="rejectConfirmationAlertModel"
    (callbackEvent)="fnRejectAlertPanelReceiver($event)"></app-alert-panel>
